import { createSlice } from '@reduxjs/toolkit';
import { getDealerSettings } from './api';
import { initialState } from './api/interface';

const leadSettingsSlice = createSlice({
  name: 'leadSettings',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(getDealerSettings.pending, (state) => {
      state.isLoading = true;
      state.isError = false;
      state.isSuccess = false;
      state.status = 'pending';
    });
    builder.addCase(getDealerSettings.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isError = false;
      state.isSuccess = true;
      state.settings = action.payload;
      state.status = 'succeeded';
    });
    builder.addCase(getDealerSettings.rejected, (state) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
      state.settings = null;
      state.status = 'failed';
    });    
  },
});

export const { reset } = leadSettingsSlice.actions;
export default leadSettingsSlice.reducer;
